import balearia_logo from "../images/logos/balearia.png";
import acciona_logo from "../images/logos/acciona.jpg";
import armas_logo from "../images/logos/acciona.jpg";
import frs_logo from "../images/logos/frs.jpg";
import flecha from "../images/flecha-card.svg";
import { AccommodationsCard } from "./accommodationsCard";


function logo(navy) {
  switch (navy) {
    case "Balearia":
      return balearia_logo;
    case "Armas":
      return armas_logo;
    case "Acciona":
      return acciona_logo;
    case "FRS":
      return frs_logo;
    default:
      return "";
  }
}

export function SailingCard({data, selectSailing, selectSailingBack, sailingSelected, sailingSelectedBack, way, selectedSailing}) {
 
  return (
    <>
      <div id="0330" className="go_div">
        <div className="o-cardTicket">
          <div className="bx">
            <div className="o-cardTicket__logo">
              <div className="bx">
                <img
                  src={logo(data.company)}
                  alt=""
            
                />
              </div>
            </div>
            <div className="o-cardTicket__trayecto">
              <div className="bx">
                <div className="row">
                  <div className="cardHead">
                    <div className="tit ht-small-bold text-center">Travesía</div>
                  </div>
                </div>
                <div className="row">
                  <div className="orDe tit">
                    <div>{data.origen}</div>
                    <div> 
                        <img src={flecha} alt="flecha-card" />
                    </div>
                    <div>{data.destiny}</div>
                  </div>
                  <div className="orDe hora">
                    <div>{data.outward_time}</div>
                      <div> 
                        <img src={flecha} alt="flecha-card" />
                      </div>
                      <div>{data.arrive_time}</div>
                    </div>
                  </div>
                </div>
            </div>
            
            <div className="o-cardTicket__selTicket">
        <div className="bx">
          <div className="row">
            <div className="cardHead loopX3">
              <div className="tit ht-small-bold text-left">Acomodación</div>
              <div className="tit ht-small-bold text-left">Flexibilidad</div>
              <div className="tit ht-small-bold text-left">Precio</div>
            </div>
          </div>

          { data.accommodations.map((element, index) => (
            <AccommodationsCard 
              key={index}
              data={element} 
              selectSailing={selectSailing} 
              selectSailingBack ={selectSailingBack}
              sailingSelected={sailingSelected}
              sailingSelectedBack={sailingSelectedBack}
              sailingData ={data}
              way = {way}
              selectedSailing={selectedSailing}/>)) 
          }
        </div>
      </div>
          </div>
        </div>
      </div>

    </>
  );
}
